export const SearchResultsPopoverId = Symbol('SEARCH_RESULTS_POPOVER');
export const CreateMenuPopoverId = Symbol('CREATE_MENU_POPOVER');
export const InfoMenuPopoverId = Symbol('INFO_MENU_POPOVER');
export const NotificationsPopoverId = Symbol('NOTIFICATIONS_POPOVER');
export const EnterpriseMenuPopoverId = Symbol('ENTERPRISE_MENU_POPOVER');
export const ChannelSwitcherPopoverId = Symbol('CHANNEL_SWITCHER_POPOPOVER');
export const MemberMenuPopoverId = Symbol('MEMBER_MENU_POPOVER');
export const TeamlessCollaborationPromptPopoverId = Symbol(
  'TEAMLESS_COLLABORATION_PROMPT_POPOVER',
);
